import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconInfo = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none" style={props.style}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={props.stroke || theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke={props.stroke || theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.01"
        stroke={props.stroke || theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
